<template>
  <div class="login-log">
    <div
      v-if="loadingDetails"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div v-else>
      <ul>
        <li
          v-for="(item, index) in loginLog"
          :key="index"
        >
          <span class="login-log-time">{{ item.time }}</span>
          <span class="login-log-method">{{ logLogin[0] }}{{ item.logintype }}{{ logLogin[1] }}</span>
          <span class="login-log-address">{{ item.region }}</span>
          <span>{{ item.carrier }}</span>
          <span>{{ item.ip }}</span>
        </li>
      </ul>
      <a-button
        v-if="loginLog.length >=10"
        :loading="loading"
        :disabled="loading"
        class="load-more-btn"
        @click="fetchData"
      >
        {{ $t('message["472"]') }}
      </a-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'LoginLog',
  data () {
    return {
      page: 1,
      loading: false,
      list: []
    }
  },
  computed: {
    ...mapState('account/accountInfo', ['loadingDetails']),
    loginLog () {
      const { list = [] } = this
      return list.map((item, index) => {
        item.time = this.$moment(item.logintime * 1000).format('YYYY-MM-DD HH:mm:ss')
        item.id = index
        return item
      })
    },
    logLogin () {
      return this.$t('message["1207"]').split('|')
    }
  },
  async mounted () {
    await this.fetchData()
  },
  methods: {
    ...mapActions('account/accountInfo', ['fetchLoginLogData']),
    async fetchData () {
      this.loading = true
      const chain = await this.fetchLoginLogData()
      chain.params({ page: this.page })
        .onSuccess(res => {
          this.list.push(...res.list)
          this.page++
          this.loading = false
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-log {
  color: #666;
  .load-more-btn {
    margin-top: 16px;
  }

  li {
    line-height: 40px;
  }

  li span {
    margin-right: 20px;
  }
}
</style>
